import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CoreI18nConfigs } from "@core/configs/i18n.config";
import { AnagraficaLegge } from "@models";
import { AnagraficaService } from "@shared/services/anagrafica.service";
import { UtilsService } from "@shared/services/utils.service";

@Component({
  selector: "app-pages-gestione-anagrafica-crea-anagrafica",
  templateUrl: "./modifica-anagrafica.component.html",
})
export class PagesGestioneAnagraficaModificaAnagraficaComponent
  implements OnInit
{
  public criteriaForm: FormGroup;
  public anagraficaLegge: AnagraficaLegge;

  constructor(
    private fb: FormBuilder,
    private anagraficaService: AnagraficaService,
    private utilsService: UtilsService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.criteriaForm = this.fb.group({
      id: [null, Validators.required],
      descrizione: [null, Validators.required],
      siglaLegge: this.fb.control(null),
    });
    this.anagraficaLegge = new AnagraficaLegge();
    this.route.params.subscribe((params) => {
      if (params["id"] != "null")
        this.anagraficaService
          .findLegge(Number(params["id"]))
          .subscribe((response) => {
            this.criteriaForm.patchValue(response);
          });
    });
  }

  public modificaLegge() {
    if (this.criteriaForm.get("descrizione")?.invalid)
      this.utilsService.showWarning("Inserire una descrizione");
    else {
      this.anagraficaService
        .updateLegge(this.criteriaForm.getRawValue())
        .subscribe((response) => {
          this.utilsService.showSuccess(
            CoreI18nConfigs.messages.genericSuccess
          );
          this.router.navigate(["../ricerca"], { relativeTo: this.route });
        });
    }
  }
}
